import { MaterialUICore, axiomTokens,Body } from '@iclinic/design-system';

const { styled } = MaterialUICore;
const { spacing, border } = axiomTokens;

export const Alert = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  border: `1px solid #ffeaa7`,
  backgroundColor: '#fff3cd',
  borderRadius: border.radius.sm,
  paddingTop: spacing[1],
  paddingBottom: spacing[1],
  marginBottom: '12px !important',

}));

export const AlertText = styled(Body)(() => ({
  color: '#ff9f43',
}));

